import FormattedAlias from '@components/_shared/Translations/FormattedAlias';
import MegapackDetails from '@components/Battery/Tesla/MegapackDetails';
import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  styled,
} from '@mui/material';

const StyledDialogTitle = styled(DialogTitle)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

interface Props {
  mpId: string;
  mpName: string;
  open: boolean;
  tscName: string;
  onClose: () => void;
}

function MPDetailsModal(props: Props) {
  const { mpId, open } = props;

  return (
    <Dialog onClose={props.onClose} open={open} maxWidth='md' fullWidth>
      <StyledDialogTitle>
        {props.tscName} {props.mpName} <FormattedAlias id='Details' />
        <IconButton onClick={props.onClose} sx={{ mr: -2, mt: -1 }}>
          <CloseIcon />
        </IconButton>
      </StyledDialogTitle>
      <DialogContent dividers>
        <Box sx={{ mt: 1, mb: 5 }}>
          {open ? <MegapackDetails selectedMpId={mpId} /> : null}
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default MPDetailsModal;
